export default async function elementorRefreshIziButton() {
    let elementorContainer = document.querySelector(".elementor-widget-container");
    if (!elementorContainer) {
        return;
    }

    checkWidgetsVisibility();

    jQuery(document.body).on('wc_fragments_refreshed', function() {
        checkWidgetsVisibility();
    });

    jQuery(document.body).on('updated_cart_totals removed_from_cart added_to_cart', function() {
        checkWidgetsVisibility();
    });

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeName === "INPOST-IZI-BUTTON") {

                    let cartItems = document.querySelector(".woocommerce-cart-form");

                    if (!cartItems) {
                        node.style.display = "none";
                    } else {
                        node.style.display = "block";
                    }
                }
            });
        }
    });

    observer.observe(elementorContainer, { childList: true, subtree: true });

    function checkWidgetsVisibility() {
        const inpostWidgets = document.querySelectorAll('[data-from-elementor="1"]');

        if (inpostWidgets.length === 0) {
            return;
        }

        const isCartEmpty = isWooCommerceCartEmpty();

        inpostWidgets.forEach(widget => {
            if (widget.getAttribute('binding_place') !== 'BASKET_SUMMARY') {
                return;
            }

            if (isCartEmpty) {
                widget.style.display = "none";
            } else {
                widget.style.display = "block";
            }
        });
    }


    function isWooCommerceCartEmpty() {
        if (document.querySelector('.wp-block-woocommerce-empty-cart-block')) {
            return true;
        }

        if (document.querySelector('.cart-empty')) {
            return true;
        }

        if (document.querySelector('.woocommerce-cart-form')) {
            return false;
        }

        if (document.querySelector('form[action*="cart"]')) {
            return false;
        }

        return false;
    }
}
